import Vue from "vue";
import VModal from "vue-js-modal";
require("dotenv").config();

import "normalize.css/normalize.css"; // a modern alternative to CSS resets

import Element from "element-ui";
import "./styles/element-variables.scss";

import "@/styles/index.scss"; // global css

import App from "./App";
import store from "./store";
import router from "./router";
import "./icons";

Vue.use(VModal);
Vue.use(Element);

Vue.config.productionTip = false;
Vue.config.silent = true;

new Vue({
  render: h => h(App),
  router,
  store
}).$mount("#app");
